export default {
    SET_DAILY_COVERS(state, dailyCovers) {
        state.dailyCovers = dailyCovers.items
        state.totalPages = dailyCovers.total_pages
    },
    ADD_DAILY_COVER(state, dailyCover) {
        state.dailyCovers.unshift(dailyCover)
    },
    DELETE_DAILY_COVER(state, dailyCoverId) {
        const ItemIndex = state.dailyCovers.findIndex((u) => u.id === dailyCoverId)
        state.dailyCovers.splice(ItemIndex, 1)
    },
    SET_DAILY_COVER_INFOS(state, dailyCover) {
        state.dailyCoverInfos = dailyCover
    }
}
